import { computed } from 'vue';

import useCurrentUserStore from './useCurrentUserStore';

export default function useCurrentUserRole() {
  const currentUserStore = useCurrentUserStore();

  return computed(() => currentUserStore.user?.role ?? null);
}
